import * as React from 'react';
import useStyles from './styles';
import Header from '../../components/Header';

export default function Updates() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header/>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
      <p>wqeqweqeqeqeeqe </p>
    </div>
  );
}
